import React, { useEffect, useState, } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const TextArea = ({ disabled, readonly, id, label, placeholder, value, valid, required, format, isValid, hint, skipValidation, rows, cols, maxLength, onChange, onClick, dataCy, }) => {
    const [isDirty, setDirty] = useState(false);
    const [isInternalValid, setInternalValid] = useState(valid);
    const [isActive, setActive] = useState(false);
    const [isRequired, setRequired] = useState(false);
    const [internalValue, setInternalValue] = useState(value);
    useEffect(() => {
        setInternalValue(value);
    }, [value]);
    const handleInvalid = (event) => {
        event.preventDefault();
        setRequired(true);
    };
    const handleChange = (event) => {
        setInternalValue(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const test = (newValue) => {
        let check;
        if (valid) {
            check = true;
        }
        else if (newValue && (format === null || format === void 0 ? void 0 : format.regex)) {
            check = new RegExp(format.regex).test(newValue);
        }
        else {
            check = false;
        }
        setDirty(true);
        setInternalValid(check);
        isValid === null || isValid === void 0 ? void 0 : isValid({ key: id, valid: check });
    };
    const textAreaProps = {
        disabled,
        readOnly: readonly,
        id,
        required,
        value: internalValue,
        placeholder,
        maxLength,
        rows,
        cols,
        onChange: (event) => {
            if (!disabled) {
                handleChange(event);
            }
        },
        onClick: (event) => {
            if (!disabled) {
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            }
        },
        onKeyUp: (event) => {
            if (!disabled) {
                if (!skipValidation) {
                    test(event.currentTarget.value);
                }
            }
        },
        onTouchEnd: (event) => {
            if (!skipValidation) {
                const eventValue = event.currentTarget.value; // store the value
                setTimeout(() => test(eventValue), 100);
            }
        },
        onFocus: () => {
            setActive(true);
            if (valid) {
                setInternalValid(true);
                setDirty(true);
            }
        },
        onBlur: () => {
            setActive(false);
        },
        onInvalid: (event) => !disabled && handleInvalid(event),
    };
    return (React.createElement("div", { className: classNames(midas.formGroup, isRequired && midas.hasWarning, isDirty && !isInternalValid && !isActive && midas.hasDanger, isDirty && !isInternalValid && isActive && midas.hasWarning, isDirty && isInternalValid && midas.hasSuccess, isDirty && valid && midas.hasSuccess), "data-cy": dataCy },
        label ? (React.createElement("label", { className: midas.formLabel, htmlFor: id },
            label,
            " ",
            required && React.createElement("span", null, "*"))) : null,
        React.createElement("textarea", { className: midas.formInput, ...textAreaProps }),
        hint ? React.createElement("span", { className: midas.formInputHint }, hint) : null,
        isDirty && !isInternalValid && !isActive && (format === null || format === void 0 ? void 0 : format.error) ? (React.createElement("span", { className: midas.formInputHint }, format.error)) : null,
        isRequired && React.createElement("span", { className: midas.formInputHint }, required)));
};
export default TextArea;
